import { useEffect } from 'react';

const SUFFIX = 'Hookpipe';

export const useTitle = (title?: string): void => {
  useEffect(() => {
    document.title = title ? `${title} · ${SUFFIX}` : SUFFIX;
    return () => {
      document.title = SUFFIX;
    };
  }, [title]);
};
